import React from 'react';
import { Bot, Brain, Code, Smartphone, ShoppingCart, Database, Network, ArrowUpRight, Warehouse, Cloud } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Bot: Bot,
  Brain: Brain,
  Code: Code,
  Smartphone: Smartphone,
  ShoppingCart: ShoppingCart,
  Database: Database,
  Network: Network,
  Warehouse: Warehouse,
  Cloud: Cloud
};

const ServicesSection = ({ onBookDemo }) => {
  return (
    <section id="services" className="py-32 bg-black relative">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#06B6D4]/30 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-2xl mb-20">
          <span className="text-[#06B6D4] text-sm font-medium tracking-wider uppercase mb-4 block">
            Our Services
          </span>
          <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-6">
            Comprehensive Tech Solutions
          </h2>
          <p className="text-xl text-white/60 leading-relaxed">
            From AI development to supply chain digitization, we deliver end-to-end technology solutions that drive business growth.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                onClick={onBookDemo}
                className="group relative bg-white/5 border border-white/10 p-8 transition-all duration-400 hover:bg-white/10 hover:border-[#06B6D4]/30 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-[#06B6D4]/10 flex items-center justify-center mb-6 group-hover:bg-[#06B6D4]/20 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-7 h-7 text-[#06B6D4]" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#06B6D4] transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-white/60 leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Link Arrow */}
                <div className="flex items-center gap-2 text-[#06B6D4] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-sm font-medium">Book a Demo</span>
                  <ArrowUpRight className="w-4 h-4" />
                </div>

                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-20 h-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute top-0 right-0 w-full h-px bg-gradient-to-l from-[#06B6D4]/50 to-transparent"></div>
                  <div className="absolute top-0 right-0 w-px h-full bg-gradient-to-b from-[#06B6D4]/50 to-transparent"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
